/* ── ¿Crédito de auto? Mejor arréndalo ────────────────────────────────────
 * Bloque de message-match para las campañas de Google Ads ("crédito de auto",
 * "deducible"). Ver brief peicar_brief_landing.md §1. Va como 2ª sección
 * (debajo del hero). CTA "Cotiza en minutos" → sube al hero/cotizador. */

const COMPARE = [
  { credito: 'Deducción topada al comprar', arr: 'Deduces tus rentas conforme a la ley' },
  { credito: 'Enganche alto y deuda en tu balance', arr: 'Pago inicial desde 10%, sin descapitalizarte' },
  { credito: 'Te quedas con un auto que se devalúa', arr: 'Renueva tu auto al terminar el plazo' },
];

const CreditoArrendamiento = ({ onQuote }) => (
  <section className="sec credito" id="credito">
    <div className="wrap reveal">
      <div className="credito-head">
        <div className="sec-eyebrow">¿Crédito de auto?</div>
        <h2 className="sec-title">¿Buscas crédito de auto? <b>Mejor arréndalo.</b></h2>
        <p className="sec-lead">
          Con arrendamiento puro (leasing) deduces tus rentas, cuidas tu flujo de efectivo
          y no te descapitalizas. Ideal para PyMES y personas físicas con actividad
          empresarial (PFAE), en CDMX y Edomex.
        </p>
      </div>

      <div className="credito-vs">
        <div className="cv-col cv-credito">
          <div className="cv-head">Crédito tradicional</div>
          {COMPARE.map((r) => (
            <div className="cv-row" key={r.credito}><span className="cv-mark cv-x">✕</span>{r.credito}</div>
          ))}
        </div>
        <div className="cv-col cv-arr">
          <div className="cv-head">Arrendamiento Peicar</div>
          {COMPARE.map((r) => (
            <div className="cv-row" key={r.arr}><span className="cv-mark cv-ok">✓</span>{r.arr}</div>
          ))}
        </div>
      </div>

      <div className="credito-cta-wrap">
        <button className="credito-cta" onClick={onQuote}>Cotiza en minutos →</button>
      </div>
    </div>
  </section>
);

export default CreditoArrendamiento;
